module.exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "De\u011Fer, ".concat(args.maxValue, " veya \xF6ncesi olmal\u0131d\u0131r.");
  },
  "rangeReversed": "Ba\u015Flang\u0131\xE7 tarihi biti\u015F tarihinden \xF6nce olmal\u0131d\u0131r.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "De\u011Fer, ".concat(args.minValue, " veya sonras\u0131 olmal\u0131d\u0131r.");
  },
  "unavailableDate": "Se\xE7ilen tarih kullan\u0131lam\u0131yor."
};